import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { ButtonToolbar } from 'reactstrap';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import { TOLL_LIQUIDATION_PATH } from '../../../../config/paths';
import {
  clearTollLiquidation,
  getTollLiquidation,
} from '../../../../actions/route/TollLiquidation';
import TollLiquidationBasicInformationResource from './resource/TollLiquidationBasicInformationResource';
import TollLiquidationDeleteButton from './TollLiquidationDeleteButton';

export const TollLiquidation = ({
  breadcrumbs,
  dispatchGetTollLiquidation,
  dispatchClearTollLiquidation,
  match: {
    params: { id },
  },
  loading,
  tollLiquidation,
}) => {
  useLayoutEffect(() => {
    dispatchGetTollLiquidation({ id });

    return () => dispatchClearTollLiquidation();
  }, []);

  let content;
  const toolbar = (
    <ButtonToolbar className="pull-right">
      <div>
        <TollLiquidationDeleteButton tollLiquidationId={id} />
      </div>
    </ButtonToolbar>
  );

  if (loading) content = <Loader />;
  else if (tollLiquidation.isEmpty())
    content = <NoDataResource returnPage={TOLL_LIQUIDATION_PATH} />;
  else {
    const routeJson = tollLiquidation.toJS();

    content = <TollLiquidationBasicInformationResource {...routeJson} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Liquidación de Peaje"
      content={content}
    />
  );
};

TollLiquidation.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearTollLiquidation: PropTypes.func.isRequired,
  dispatchGetTollLiquidation: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  tollLiquidation: PropTypes.instanceOf(Immutable.Map).isRequired,
};

TollLiquidation.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearTollLiquidation: clearTollLiquidation,
  dispatchGetTollLiquidation: getTollLiquidation,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Liquidación de Peajes',
      href: TOLL_LIQUIDATION_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  tollLiquidation: RouteUnit.TollLiquidation.getIn(['current', 'content']),
  loading: !RouteUnit.TollLiquidation.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(TollLiquidation);
